define('services/common/dialog-questionnaire-tip-service',['app', 'angular'], function (app, angular) {
    app.factory('dialogQuestionnaireTip', ['ngDialog','auiDialog','OpenUp', function (ngDialog,auiDialog,OpenUp) {

        /**
         * common function
         * @param template urls for template
         * @return {Function}
         */

        function common(template) {
            return function (args) {
                var handler = ngDialog.open({
                    template: template,
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', '$window', '$timeout',function ($scope,$window,$timeout) {
                    	//不愿反馈
                        $scope.notToQuestionnaire = function () {
                        	var param = {
                        			req:{
                        				answerForQuestionnaire:{
                        					signStatus:2
                        				}
                        			}
                        	}
                        	OpenUp.fillQuestionnaire(param).then(function(data){
                        		if(data.resultCode == 0){
                        			handler.close();
                        			if(args.toNotQuestionnaireDeal){
                        				args.toNotQuestionnaireDeal();
                        			}
                        		}
                        	});
                        };
                        
                        //愿意反馈
                        $scope.toQuestionnaire = args.toQuestionnaireDeal?function(){
                        	args.toQuestionnaireDeal();
                        	handler.close();
                        }:handler.close;
                    }]
                })
            };
        }

        return {
        	openQuestionnaireTipDialog: common('pages/common/dialog.questionnaire.html')
        };

    }]);
});
